// Tiny trend line for a KPI card. Plain SVG: it has no axes or hover, and a
// Recharts container per card would cost four ResizeObservers for a 40px line.
export default function Sparkline({ values = [], height = 40 }) {
  const width = 200;
  const points = Array.isArray(values) ? values.filter(Number.isFinite) : [];
  if (points.length < 2) {
    return <div style={{ height }} aria-hidden="true" />;
  }

  const max = Math.max(...points) || 1;
  const step = width / (points.length - 1);
  const y = (v) => (height - (v / max) * height * 0.9).toFixed(1);
  const line = points
    .map((v, i) => `${i ? "L" : "M"}${(i * step).toFixed(1)} ${y(v)}`)
    .join(" ");
  const area = `${line} L ${width} ${height} L 0 ${height} Z`;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className="block w-full"
      style={{ height }}
      aria-hidden="true"
    >
      <path d={area} fill="#EEF2FF" />
      <path
        d={line}
        fill="none"
        stroke="#4F46E5"
        strokeWidth="1.75"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
